import { render, staticRenderFns } from "./ExtractionTemplateDraftStatus.vue?vue&type=template&id=197955ae&scoped=true&"
import script from "./ExtractionTemplateDraftStatus.vue?vue&type=script&lang=js&"
export * from "./ExtractionTemplateDraftStatus.vue?vue&type=script&lang=js&"
import style0 from "./ExtractionTemplateDraftStatus.vue?vue&type=style&index=0&id=197955ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197955ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
